import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  error: { defaultMessage: 'Impossible to display this type of media', id: '21H5M6' },
});

export const EmbedError: React.FC = () => {
  return (
    <div className="EmbedError flex justify-center">
      <FormattedMessage {...messages.error} />
    </div>
  );
};
